/**
 * IntegratedSummaryReportDTO represents a score model with override capability
 * Based on the Java DTO from it.nexi.iap.dto.IntegratedSummaryReportDTO
 */
class IntegratedSummaryReportDTO {
  /**
   * Constructs an IntegratedSummaryReportDTO
   * @param {Object} data - The data to initialize the DTO with
   */
  constructor(data = {}) {
    // Main properties
    this.company = data.company || null; // Legal Entity (LE)
    this.fy = data.fy || null; // Fiscal Year
    this.period = data.period || null; // Period
    this.ctrf = data.ctrf || null; // Funzione di Controllo (FdC)

    // Scores from specific tables based on CTRF/INDEX
    this.qltScore = data.qltScore || null;
    this.qntScore = data.qntScore || null;
    this.overallScore = data.overallScore || null;

    this.esito = data.esito || null; // Outcome - to be defined

    // Override information
    this.overrideScoreValue = data.overrideScoreValue || null;
    this.overrideComment = data.overrideComment || null;
    this.overrideLastModifiedAt = data.overrideLastModifiedAt || null;
    this.overrideNmUser = data.overrideNmUser || null;
    this.editable = typeof data.editable === "boolean" ? data.editable : null;
    console.log("DATA:",data)
    console.log("data.editable",data.editable)
  }

  /**
   * Creates a builder for IntegratedSummaryReportDTO
   * @returns {IntegratedSummaryReportDTO.Builder} A new builder instance
   */
  static builder() {
    return new IntegratedSummaryReportDTO.Builder();
  }

  /**
   * Constructs an instance of IntegratedSummaryReportDTO from an object
   * @param {Object} data The data to create the instance from
   * @returns {IntegratedSummaryReportDTO} An instance of IntegratedSummaryReportDTO
   */
  static constructFromObject(data) {
    if (data === null || data === undefined) {
      return null;
    }
    return new IntegratedSummaryReportDTO(data);
  }
}

/**
 * Builder class for IntegratedSummaryReportDTO
 */
IntegratedSummaryReportDTO.Builder = class Builder {
  constructor() {
    this._company = null;
    this._fy = null;
    this._period = null;
    this._ctrf = null;
    this._qltScore = null;
    this._qntScore = null;
    this._overallScore = null;
    this._esito = null;
    this._overrideScoreValue = null;
    this._overrideComment = null;
    this._overrideLastModifiedAt = null;
    this._overrideNmUser = null;
    this._editable = false;
  }

  company(company) {
    this._company = company;
    return this;
  }

  fy(fy) {
    this._fy = fy;
    return this;
  }

  period(period) {
    this._period = period;
    return this;
  }

  ctrf(ctrf) {
    this._ctrf = ctrf;
    return this;
  }

  qltScore(qltScore) {
    this._qltScore = qltScore;
    return this;
  }

  qntScore(qntScore) {
    this._qntScore = qntScore;
    return this;
  }

  overallScore(overallScore) {
    this._overallScore = overallScore;
    return this;
  }

  esito(esito) {
    this._esito = esito;
    return this;
  }

  overrideScoreValue(overrideScoreValue) {
    this._overrideScoreValue = overrideScoreValue;
    return this;
  }

  overrideComment(overrideComment) {
    this._overrideComment = overrideComment;
    return this;
  }

  overrideLastModifiedAt(overrideLastModifiedAt) {
    this._overrideLastModifiedAt = overrideLastModifiedAt;
    return this;
  }

  overrideNmUser(overrideNmUser) {
    this._overrideNmUser = overrideNmUser;
    return this;
  }

  editable(editable) {
    this._editable = editable;
    return this;
  }

  build() {
    return new IntegratedSummaryReportDTO({
      company: this._company,
      fy: this._fy,
      period: this._period,
      ctrf: this._ctrf,
      qltScore: this._qltScore,
      qntScore: this._qntScore,
      overallScore: this._overallScore,
      esito: this._esito,
      overrideScoreValue: this._overrideScoreValue,
      overrideComment: this._overrideComment,
      overrideLastModifiedAt: this._overrideLastModifiedAt,
      overrideNmUser: this._overrideNmUser,
      editable: this._editable
    });
  }
};

export default IntegratedSummaryReportDTO;
